<template>
    <div class="px-5 py-5">
        <!-- filter -->
        <div class="filter-list row">
            <div class="col-lg-3">
                <label style="display: block;">Học viên (tên / SĐT)</label>
                <el-input v-model="filter.search" placeholder="Tìm kiếm học viên" clearable size="medium" />
            </div>
            <div class="col-lg-2">
                <label style="display: block;">Trung tâm</label>
                <el-select v-model="filter.center_id" placeholder="Tất cả" class="w-100" clearable filterable>
                    <el-option v-for="c in centers" :key="c.id" :label="c.name" :value="c.id" />
                </el-select>
            </div>
            <div class="col-lg-2">
                <label style="display: block;">Trạng thái</label>
                <el-select v-model="filter.status" placeholder="Tất cả" class="w-100" clearable>
                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                </el-select>
            </div>
            <div class="col-lg-3">
                <label style="display: block;">Thời gian tạo</label>
                <el-date-picker v-model="filter.dateRange" type="daterange" range-separator="đến"
                    start-placeholder="Từ ngày" end-placeholder="Đến ngày" align="right" unlink-panels clearable
                    size="medium" format="dd/MM/yyyy" value-format="yyyy-MM-dd" />
            </div>
            <div class="col-lg-2 d-flex align-items-end">
                <el-button type="primary" size="medium" @click="search">Tìm kiếm</el-button>
            </div>
        </div>

        <!-- summary -->
        <div class="mt-3 text-muted" style="font-size: 13px;">
            Tổng: <strong>{{ total }}</strong> bản ghi
        </div>

        <!-- table -->
        <div class="table-responsive mt-3" style="max-height: 900px">
            <table class="table table-bordered table-hover text-nowrap">
                <thead class="thead-light">
                    <tr>
                        <th>STT</th>
                        <th>Học viên</th>
                        <th>Buổi nghỉ</th>
                        <th>Trung tâm</th>
                        <th>Trạng thái</th>
                        <th>TL video</th>
                        <th>TL đã học</th>
                        <th>Thời gian tạo</th>
                    </tr>
                </thead>
                <tbody v-if="tableLoading">
                    <tr>
                        <td colspan="8" style="text-align: center"><i class="el-icon-loading"></i></td>
                    </tr>
                </tbody>
                <tbody v-else-if="items.length === 0">
                    <tr>
                        <td colspan="8" style="text-align: center"><span>Không có dữ liệu</span></td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr v-for="(item, index) in items" :key="item.id">
                        <td>{{ (page - 1) * perPage + index + 1 }}</td>
                        <td>{{ item.student_label }}</td>
                        <td>{{ item.lesson_label }}</td>
                        <td>{{ item.center_name }}</td>
                        <td>
                            <span :class="getStatusClass(item.status)">{{ item.status }}</span>
                        </td>
                        <td>{{ formatDuration(item.video_duration) }}</td>
                        <td>{{ formatDuration(item.watched_duration) }}</td>
                        <td>{{ item.created_at }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- pagination -->
        <div class="d-flex justify-content-end mt-3" v-if="total > 0">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="perPage"
                :current-page="page"
                @current-change="onPageChange"
            />
        </div>
    </div>
</template>

<script>
import { GET_MAKEUP_VIDEO_REPORT, EXPORT_MAKEUP_VIDEO_REPORT } from '../../../../core/services/store/tutor/tutor.module';
import { GET_GUARANTEE_VIDEO_CENTERS } from '../../../../core/services/store/center/centers.module';
import { exportExcel } from '@/core/filters';

const EXPORT_HEADERS = [
    { key: 'makeup_video_code', value: 'Mã video lượt nghỉ' },
    { key: 'video_id', value: 'Mã video' },
    { key: 'video_name', value: 'Tên video' },
    { key: 'status', value: 'Trạng thái' },
    { key: 'student_code', value: 'Mã học viên' },
    { key: 'student_name', value: 'Tên học viên' },
    { key: 'phone', value: 'Số điện thoại' },
    { key: 'center_name', value: 'Trung tâm' },
    { key: 'branch_name', value: 'Chi nhánh' },
    { key: 'course_name', value: 'Khóa học' },
    { key: 'class_name', value: 'Lớp học' },
    { key: 'lesson', value: 'Buổi' },
    { key: 'video_duration', value: 'Thời lượng video (giây)' },
    { key: 'watched_duration', value: 'Thời lượng đã học (giây)' },
    { key: 'created_at', value: 'Thời gian tạo' },
]

export default {
    name: "TutorVideoReport",
    data() {
        return {
            filter: {
                search: '',
                center_id: '',
                status: '',
                dateRange: [],
            },
            items: [],
            total: 0,
            page: 1,
            perPage: 15,
            tableLoading: false,
            centers: [],
            statusOptions: [
                { value: 'watched', label: 'Đã xem' },
                { value: 'cancelled', label: 'Hủy' },
                { value: 'unwatched', label: 'Chưa xem' },
            ],
        }
    },
    methods: {
        buildParams() {
            const params = { page: this.page, per_page: this.perPage }
            if (this.filter.search) params.search = this.filter.search
            if (this.filter.center_id) params.center_id = this.filter.center_id
            if (this.filter.status) params.status = this.filter.status
            if (this.filter.dateRange && this.filter.dateRange.length === 2) {
                params.date_from = this.filter.dateRange[0]
                params.date_to   = this.filter.dateRange[1]
            }
            return params
        },
        async fetchData() {
            try {
                this.tableLoading = true
                const res = await this.$store.dispatch(GET_MAKEUP_VIDEO_REPORT, this.buildParams())
                this.items = res.data || []
                this.total = res.meta?.total || 0
            } catch {
                this.$message({ message: 'Lỗi tải dữ liệu', type: 'error' })
            } finally {
                this.tableLoading = false
            }
        },
        search() {
            this.page = 1
            this.fetchData()
        },
        onPageChange(p) {
            this.page = p
            this.fetchData()
        },
        async exportReport() {
            try {
                const params = this.buildParams()
                delete params.page
                delete params.per_page
                const res = await this.$store.dispatch(EXPORT_MAKEUP_VIDEO_REPORT, params)
                exportExcel(EXPORT_HEADERS, res.data, 'Danh sách lượt học video buổi nghỉ.xlsx', false)
            } catch {
                this.$message({ message: 'Lỗi xuất file', type: 'error' })
            }
        },
        async loadCenters() {
            try {
                const res = await this.$store.dispatch(GET_GUARANTEE_VIDEO_CENTERS)
                this.centers = res.data || []
            } catch {}
        },
        formatDuration(seconds) {
            if (seconds === null || seconds === undefined || seconds === '') return '--'
            const s = parseInt(seconds, 10)
            if (isNaN(s)) return '--'
            const m = Math.floor(s / 60)
            const sec = s % 60
            return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
        },
        getStatusClass(status) {
            const map = {
                'Đã xem': 'badge badge-success',
                'Hủy': 'badge badge-secondary',
                'Chưa xem': 'badge badge-warning',
            }
            return map[status] || ''
        },
    },
    mounted() {
        this.loadCenters()
        this.fetchData()
    }
}
</script>
